import { render, staticRenderFns } from "./DashboardAccountManager.vue?vue&type=template&id=3c8a5037"
import script from "./DashboardAccountManager.vue?vue&type=script&lang=js"
export * from "./DashboardAccountManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports